import { render } from "./PurchaseReceipt.vue?vue&type=template&id=25e21665"
import script from "./PurchaseReceipt.vue?vue&type=script&lang=js"
export * from "./PurchaseReceipt.vue?vue&type=script&lang=js"

import "./purchase-receipt.css?vue&type=style&index=0&lang=css"
import "./receipt-confirmation-hero.css?vue&type=style&index=1&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__